import React, {Fragment, useState} from 'react'
import { useTranslation } from 'react-i18next';

export default props => {

  // const {
    // answerHandlerOpen,
    // toggleAnswerHandler,
    // doUpdateItem,
    // items,
    // item,
  // } = props

  const [buttonIcon, setButtonIcon] = useState('icon_modulo')

  const { i18n } = useTranslation();

  // const ancestor = item && items ? items.find(i => i._id === item.ancestorItem) : undefined

  return (
    <Fragment>
      <div className="form-group">
        <button className="settings-conditional-button-create-condition"
                onClick={() => {}}
                onMouseEnter={() => {setButtonIcon('icon_modulo_hover')}}
                onMouseLeave={() => {setButtonIcon('icon_modulo')}}>
          <img alt="" src={require(`../../../assets/images/${buttonIcon}.svg`)}/>
          &nbsp;&nbsp;{i18n.t('Expandir módulo')}
        </button>
      </div>
    </Fragment>
  )
}
